export const STUDIO = {
  name: "L'écho du copeau",
  tagline: "Ébénisterie — Meubles sur mesure & agencement d'intérieur",
  city: "Aix-en-Provence",
  phone: "06 71 33 38 64",
  phoneHref: "tel:+33671333864",
  email: "slys@live.fr",
  emailHref: "mailto:slys@live.fr",
  address: "Aix-en-Provence",
};

export const HERO_IMAGE = "/images/hero.jpg";

export const WORKSHOP_IMAGE = "/images/manifeste.jpg";

export const SPOTLIGHT_IMAGE = "/images/atelier.jpg";

export const SERVICES = [
  {
    num: "01",
    title: "Meubles sur mesure",
    text: "Chaque pièce est dessinée puis façonnée à la main pour épouser votre espace et vos usages. Bois massif, assemblages traditionnels, finitions adaptées.",
  },
  {
    num: "02",
    title: "Agencement d'intérieur",
    text: "Façades de cuisines, bibliothèques, dressings, placards. Nous concevons des aménagements complets qui marient fonctionnalité et élégance intemporelle.",
  },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Le dessin",
    text: "Tout commence sur le papier : le travail débute dès la conception. Chaque pièce est dessinée et ses proportions étudiées avant même de toucher le bois.",
  },
  {
    num: "02",
    title: "La matière",
    text: "Chêne, noyer, hêtre — des essences nobles sélectionnées pour leur caractère et leur durabilité, sourcées de manière responsable.",
  },
  {
    num: "03",
    title: "Le geste",
    text: "La main guide l'outil. La précision de l'assemblage et la patience de la finition font la différence entre un meuble et une œuvre.",
  },
];